"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notFoundError = exports.permissionError = exports.validationError = exports.applicationError = void 0;
var error_box_1 = require("@cd2/error-box");
exports.applicationError = (0, error_box_1.createBox)("fileboy");
exports.validationError = exports.applicationError.extend("validation");
exports.permissionError = exports.applicationError.extend("permission");
exports.notFoundError = exports.applicationError.extend("notFound");
